/**
 * Classe responsável pelas ações no mapa
 * @author: Adalto Junior adaltojunior@sagarantech.com
 * DATE: 04/02/2013
 * @version: 1.0
 */


Greenmile.SmartGeocode = Greenmile.SmartGeocode || {};
Greenmile.SmartGeocode.Map = function (locationId) {

    var id = locationId;
    var lengthSmartGeocode = Greenmile.SmartGeocode.data.length;
    var positionSmartGeocode = Greenmile.SmartGeocode.data.getPositionByLocationId(id);
    var mapInstance;

    var removeCorrectPosition = function (map) {

        var layers = map._layers;

        for (var key in layers) {

            var layer = layers[key];

            if (typeof(layer.type) !== "undefined" && layer.type === "correctPosition") {
                map.removeLayer(layer);
            }
        }

    };


    var setCorrectLocation = function (lat, lng) {

        Greenmile.SmartGeocode.correctPosition = { latitude: lat, longitude: lng };

    };

    var addMarkerCorrectPosition = function (position, map) {

        removeCorrectPosition(map);

        var icon = L.divIcon({
            iconAnchor: new L.Point(0, 0),
            iconSize: [15, 15],
            html: '<div class="smartGeocodePointer"></div>'
        });

        var latlng = new L.LatLng(position.lat, position.lng);

        var marker = new L.marker(latlng, {
            icon: icon,
            clickable: true
        });

        marker.type = "correctPosition";

        marker.addTo(map);

        map.panTo(latlng);

        setCorrectLocation(position.lat, position.lng);

    };

    var goToNextSmartGocode = function () {

        positionSmartGeocode += 1;

        if (positionSmartGeocode < lengthSmartGeocode) {

            var smartGeocode = Greenmile.SmartGeocode.data.at(positionSmartGeocode);
            var locationId = smartGeocode.attributes.locationId;

            window.location.href = "#/SmartGeocode/" + locationId + "/detail";

        }

    };

    var updateAndGoToNextSmartGocode = function () {


        var oldModel = Greenmile.SmartGeocode.data.at(positionSmartGeocode);

        positionSmartGeocode += 1;

        if (positionSmartGeocode < lengthSmartGeocode) {

            var smartGeocode = Greenmile.SmartGeocode.data.at(positionSmartGeocode);
            var locationId = smartGeocode.attributes.locationId;

            Greenmile.SmartGeocode.data.remove(oldModel);

            positionSmartGeocode -= 1;

            window.location.href = "#/SmartGeocode/" + locationId + "/detail";

        }

    };

    var goToPreviousSmartGocode = function () {

        positionSmartGeocode -= 1;

        if (positionSmartGeocode >= 0) {

            var smartGeocode = Greenmile.SmartGeocode.data.at(positionSmartGeocode);
            var locationId = smartGeocode.attributes.locationId;

            window.location.href = "#/SmartGeocode/" + locationId + "/detail";

        }

    };

    var updateFitBounds = function (map) {

        var layers = map._layers;
        var markers = [];

        for (var key in layers) {
            var layer = layers[key];

            if (typeof(layer.type) !== "undefined" && (layer.type === "correctPosition" || layer.type === "actualPosition" || layer.type === "listPosition")) {
                markers.push([layer._latlng.lat, layer._latlng.lng]);
            }
        }

        if (markers.length > 0) {
            map.fitBounds(markers);
        }

    };

    var eventButtonCancel = function () {

        document.querySelector("#SmartGeocode").innerHTML = "";
        var route = new App.Routers.SmartGeocode();
        route.returnToGrid();

    };

    var eventButtonSavePosition = function () {

        document.querySelector("#SmartGeocode").innerHTML = "";
        var routeSmartgeocode = new App.Routers.SmartGeocode();
        routeSmartgeocode.updatePosition(locationId, eventButtonCancel);

    };

    var eventButtonSavePositionAndNext = function () {

        document.querySelector("#SmartGeocode").innerHTML = "";
        var routeSmartgeocode = new App.Routers.SmartGeocode();
        routeSmartgeocode.updatePosition(locationId, updateAndGoToNextSmartGocode);

    };

    var eventButtonRejectPositionAndNext = function () {

        document.querySelector("#SmartGeocode").innerHTML = "";
        var smartGeocodeRoute = new App.Routers.SmartGeocode();
        smartGeocodeRoute.setCheckedPosition(locationId, updateAndGoToNextSmartGocode);
    };

    var eventButtonRejectPosition = function () {

        document.querySelector("#SmartGeocode").innerHTML = "";
        var smartGeocodeRoute = new App.Routers.SmartGeocode();
        smartGeocodeRoute.setCheckedPosition(locationId, eventButtonCancel);
    };

    var eventButtonNext = function () {

        document.querySelector("#SmartGeocode").innerHTML = "";
        goToNextSmartGocode();

    };

    var eventButtonPrevious = function () {

        document.querySelector("#SmartGeocode").innerHTML = "";
        goToPreviousSmartGocode();

    };

    this.formatContentPopupCurrentPosition = function (location) {
        var model = new App.Models.Location(location);
        var content = '<div class="stopDetailStopName"><span class="stopDetailStopTitle">' + model.attributes.key + ' - ' + model.attributes.description + '</span></div>';
        content += '<div class="stopDetailAddress">';
        content += '<span style="font-weight: bold">' + Monet.I18n.getResourcesByKey('Smartgeocode.Map.address') + ':</span>';
        content += model.getItemsOfAddress().join(", ");
        content += '</div>';
        return content;
    };

    this.addMarkerActualPosition = function (location, map) {

        var point = new L.Point(39, 2);
        var icon = new L.Icon({
            iconUrl: require("static/images/map/markers/location.png")
        });

        var latlng = new L.LatLng(location.latitude, location.longitude);
        var marker = new L.marker(latlng, {
            icon: icon,
            clickable: true
        });

        var contentPopup = this.formatContentPopupCurrentPosition(location);

        marker.bindPopup(contentPopup, {
            offset: point
        }).openPopup();

        marker.type = "actualPosition";

        marker.addTo(map);

        setCorrectLocation(location.latitude, location.longitude);

        updateFitBounds(map);

    };

    this.addEventListener = function () {

        var btnSave = document.querySelector("#SmartGeocode #save");
        var btnSaveAndNext = document.querySelector("#SmartGeocode #saveAndNext");
        var btnRejectAndNext = document.querySelector("#SmartGeocode #rejectAndNext");
        var btnReject = document.querySelector("#SmartGeocode #reject");
        var btnCancel = document.querySelector("#SmartGeocode #cancel");
        var btnPrevious = document.querySelector("#SmartGeocode #previous");
        var btnNext = document.querySelector("#SmartGeocode #next");

        btnSave.removeEventListener("click", eventButtonSavePosition);
        btnSave.addEventListener("click", eventButtonSavePosition);

        btnSaveAndNext.removeEventListener("click", eventButtonSavePositionAndNext);
        btnSaveAndNext.addEventListener("click", eventButtonSavePositionAndNext);

        btnRejectAndNext.removeEventListener("click", eventButtonRejectPositionAndNext);
        btnRejectAndNext.addEventListener("click", eventButtonRejectPositionAndNext);

        btnReject.removeEventListener("click", eventButtonRejectPosition);
        btnReject.addEventListener("click", eventButtonRejectPosition);

        btnCancel.removeEventListener("click", eventButtonCancel);
        btnCancel.addEventListener("click", eventButtonCancel);

        btnPrevious.removeEventListener("click", eventButtonPrevious);
        btnPrevious.addEventListener("click", eventButtonPrevious);

        btnNext.removeEventListener("click", eventButtonNext);
        btnNext.addEventListener("click", eventButtonNext);

        btnSave.setAttribute("disabled", "disabled");
        btnSaveAndNext.setAttribute("disabled", "disabled");

        if (lengthSmartGeocode === 1 || positionSmartGeocode === lengthSmartGeocode - 1) {
            btnSaveAndNext.setAttribute("disabled", "disabled");
            btnRejectAndNext.setAttribute("disabled", "disabled");
            btnNext.setAttribute("disabled", "disabled");
        }

        if (positionSmartGeocode === 0 || lengthSmartGeocode === 1) {
            btnPrevious.setAttribute("disabled", "disabled");
        }

    };

    this.createMap = function () {

        var divMap = document.getElementById('smartGeocodeMap');
        divMap.setAttribute('class', 'background-map');

        var mapConfs = Greenmile.Map.Utility.getMapLocalStorageConfiguration();

        var map = Greenmile.Map.Utility.createDefaultMap("smartGeocodeMap");
        var baseLayer = Greenmile.Map.Utility.createBaseLayer();

        map.addLayer(baseLayer);

        var mapSourceControl = new Greenmile.Toolbar.Map.MapSourceControl(null, map);
        mapSourceControl.setSourceMap(mapConfs.supplierMap, map, { mapBaseLayer: baseLayer });

        //armazena a referência do baseLayer
        if (typeof Greenmile.SmartGeocode !== "undefined") {
            Greenmile.SmartGeocode.mapBaseLayer = baseLayer;
        }

        var clickOnMap = function (e) {

            addMarkerCorrectPosition(e.latlng, this);
            var btnSave = document.querySelector("#SmartGeocode #save");
            var btnSaveAndNext = document.querySelector("#SmartGeocode #saveAndNext");
            btnSave.removeAttribute("disabled");
            btnSaveAndNext.removeAttribute("disabled");
        };

        map.off('click', clickOnMap);
        map.on('click', clickOnMap.bind(map));

        mapInstance = map;

        return map;
    };

    this.addMarkerListPositions = function (listPosition, map, location) {

        var listPositionLength = listPosition.length;
        var point = new L.Point(38, 2);

        L.ListPosition = L.Icon.extend({

            options: {
                shadowUrl: null,
                iconAnchor: new L.Point(0, 0),
                popupAnchor: point,
                className: ''
            },

            createIcon: function () {

                var div = document.createElement('div');

                div.innerHTML = '<div class="iconPositionList"></div>';

                this._setIconStyles(div, 'icon');

                return div;
            },

            createShadow: function () {
                return null;
            }
        });

        for (var i = 0; i < listPositionLength; i++) {

            var position = listPosition[i].position;
            var dateDefault = listPosition[i].date;
            var latlng = new L.LatLng(position.latitude, position.longitude);
            var marker = new L.marker(latlng, {
                icon: new L.ListPosition({}),
                clickable: true
            });

            const dateTime = Monet.Format.DateTime.formatToLocale(location.geocodingDate || dateDefault);

            marker.bindPopup(dateTime, {
                offset: point
            }).openPopup();

            marker.type = "listPosition";

            marker.on('click', (point) => {
              addMarkerCorrectPosition(point.latlng, map);
              var btnSave = document.querySelector("#SmartGeocode #save");
              var btnSaveAndNext = document.querySelector("#SmartGeocode #saveAndNext");
              btnSave.removeAttribute("disabled");
              btnSaveAndNext.removeAttribute("disabled");
            })

            marker.addTo(map);

        }

    };

};
